var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Google__G__logo",
    transform: "translate(-1 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_344",
    "data-name": "Trazado 344",
    d: "M22.56,12.25a12.639,12.639,0,0,0-.2-2.25H12v4.26h5.92a5.072,5.072,0,0,1-2.21,3.31v2.77h3.57a10.747,10.747,0,0,0,3.28-8.09Z",
    fill: "#4285f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_345",
    "data-name": "Trazado 345",
    d: "M12,23a10.5,10.5,0,0,0,7.28-2.66l-3.57-2.77A6.614,6.614,0,0,1,5.84,14.1H2.18v2.84A10.99,10.99,0,0,0,12,23Z",
    fill: "#34a853"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_346",
    "data-name": "Trazado 346",
    d: "M5.84,14.09a6.415,6.415,0,0,1,0-4.18V7.07H2.18a10.889,10.889,0,0,0,0,9.86l2.85-2.22.81-.62Z",
    fill: "#fbbc05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_347",
    "data-name": "Trazado 347",
    d: "M12,5.38a6,6,0,0,1,4.21,1.64l3.15-3.15A10.553,10.553,0,0,0,12,1,10.981,10.981,0,0,0,2.18,7.07L5.84,9.91A6.567,6.567,0,0,1,12,5.38Z",
    fill: "#ea4335"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_348",
    "data-name": "Trazado 348",
    d: "M1,1H23V23H1Z",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.24402859d5359a1d6a869e4f20022f6a.svg";
export { ForwardRef as ReactComponent };